import {
	getCapturedTraceIds,
	recordTraceId,
	startCapturingTraceIdsForOperation,
	stopCapturingTraceIdsForOperation,
} from './trace-id-store';

export const startCapturingTraceIds = (operationName: string): void => {
	startCapturingTraceIdsForOperation(operationName);
};

export const stopCapturingTraceIds = (operationName: string): void => {
	stopCapturingTraceIdsForOperation(operationName);
};

export const addTraceId = (
	operationName: string,
	traceId?: string,
	variables?: Record<string, unknown>,
): void => {
	recordTraceId(operationName, traceId, variables);
};

export const getTraceIds = (operationName: string): string[] => getCapturedTraceIds(operationName);
